import { render, staticRenderFns } from "./ClassGo.vue?vue&type=template&id=07f1cdf8&scoped=true&"
import script from "./ClassGo.vue?vue&type=script&lang=js&"
export * from "./ClassGo.vue?vue&type=script&lang=js&"
import style0 from "./ClassGo.vue?vue&type=style&index=0&id=07f1cdf8&lang=less&scoped=true&"
import style1 from "./ClassGo.vue?vue&type=style&index=1&id=07f1cdf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1cdf8",
  null
  
)

export default component.exports